import config from "config";
import { RequestPasswordResetCommand } from "src/types/generated/requestPasswordResetCommand";

/**
 * resetPassword
 */
const resetPassword = async ({ email }: RequestPasswordResetCommand): Promise<string> => {

  const headers = {
    accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const response = await fetch(
    `${config.backend.apiAddress}Auth/requestPasswordReset`, {
    method: 'POST',
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    headers,
    body: JSON.stringify({email}),
  });
  
  console.log(response);

  if (!response.ok)
    throw new Error("Fail");

  return new Promise((resolve) => resolve("OK"));
};

export default resetPassword;

